import { render, staticRenderFns } from "./Distritos.vue?vue&type=template&id=0852c1a4&"
import script from "./Distritos.vue?vue&type=script&lang=js&"
export * from "./Distritos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports